/** @jsxImportSource @emotion/react */
import { useEffect, useRef, useState, useContext, memo, useMemo } from "react";
import { ScrollingCarousel } from "@trendyol-js/react-carousel";
import Drawer from "@mui/material/Drawer";
import {
  IconButton,
  Box,
  Typography,
  ClickAwayListener,
  Skeleton,
} from "@mui/material";
import FlightIcon from "@mui/icons-material/Flight";
import TheatersIcon from "@mui/icons-material/Theaters";
import ChildCareIcon from "@mui/icons-material/ChildCare";
import RestaurantIcon from "@mui/icons-material/Restaurant";
import SportsSoccerIcon from "@mui/icons-material/SportsSoccer";
import CategoryIcon from "@mui/icons-material/Category";
import {
  useNavigate,
  useLocation,
  useSearchParams,
  NavLink,
} from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { useProfile } from "../../hooks/services/Profile";
import { useModellist } from "../../hooks/services/useModels";
import Stories, { WithSeeMore } from "react-insta-stories";
import Modal from "react-bootstrap/Modal";
// import Tooltip from '@mui/material/Tooltip';
// import { Document, Page } from 'react-pdf/dist/esm/entry.webpack';
import { Document, Page, pdfjs } from "react-pdf";
import AppBar from "../../components/AppBar";
// import AppFooter from "../../components/AppFooter";
import Footer1 from "../../components/Footer/Footer";
import StoreCard from "./components/StoreCard";
import { useGetHomeScreenStyles } from "./index.styles";
import { Useseenmodels } from "../../hooks/services/modelseen";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { appendAuthToken } from "../../utils/authSession";
import uuid from "react-uuid";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import Dropdown from "../../components/Dropdown";
import DrawerSearchContent from "./drawerSearchContent";
import { useInterval } from "../../hooks/useInterval";
import { usePopupseenuser } from "../../hooks/services/popupseenuser";
import { useGetNavItems } from "./appbarNav";
import { useHome } from "../../hooks/services/useHome";
import { useBrand } from "../../hooks/services/useBrand";
import { useCategory } from "../../hooks/services/useCategory";
import { useSubCategory } from "../../hooks/services/useSubCategory";
import { useMail } from "../../hooks/services/useMail";
import { useCountry } from "../../hooks/services/useCountry";
import { UserContext } from "../../context/UserContext";
import { usePopupseen } from "../../hooks/services/PopupSeen";
import { useStateData } from "../../hooks/services/useStateData";
import { useCountyData } from "../../hooks/services/useCountyData";
import { useCityData } from "../../hooks/services/useCityData";
import { usePopAddslist } from "../../hooks/services/usePopupadds";
import Snackbar from "../../components/Snackbar";
import VideoPlayer from "../../components/VideoPlayer";
import { useDoYouKnow } from "../../hooks/useDoYouKnow";
import { useQuickOffers } from "../../hooks/useQuickOffers";
import {
  getCollection,
  getTotalCount,
  useActiveCampaigns,
} from "../../hooks/useCampaignQueries";
import { COMING_SOON } from "../../constants";
import { Notificationconsumer } from "../../hooks/services/notifications";
import ToggleButton from "react-toggle-button";
import BootstrapSwitchButton from "bootstrap-switch-button-react";
import { baseUrl } from "../../connections";
import axios from "axios";
import MailGrid from "./components/MailGrid";
import CampaignsPanel from "../Campaigns/components/CampaignsPanel";

import { Viewer } from "@react-pdf-viewer/core";
import { toast } from "react-toastify";

// Import the styles
import "@react-pdf-viewer/core/lib/styles/index.css";

const DO_YOU_KNOW_TAB_UUID = "__do_you_know__";
const QUICK_OFFERS_TAB_UUID = "__quick_offers__";
const CATEGORY_HIGHLIGHT = "#20A64A";

// Matches the native app's category icon fallback — a store's own image
// (when set) wins, otherwise a generic icon keyed off the category name so
// an empty catalog still reads as a real category, not a blank circle.
const getCategoryIcon = (name = "") => {
  const key = String(name).toLowerCase();
  if (key.includes("air") || key.includes("travel") || key.includes("flight")) {
    return FlightIcon;
  }
  if (key.includes("box office") || key.includes("movie") || key.includes("cinema")) {
    return TheatersIcon;
  }
  if (key.includes("day care") || key.includes("child")) {
    return ChildCareIcon;
  }
  if (key.includes("restaurant") || key.includes("food") || key.includes("dining")) {
    return RestaurantIcon;
  }
  if (key.includes("sport")) {
    return SportsSoccerIcon;
  }
  return CategoryIcon;
};

pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@2.16.105/build/pdf.worker.min.js`;

const MobileHome = () => {
  const [redeemError, setRedeemError] = useState(false);
  const [isRedeem, setIsRedeem] = useState(false);
  const [showpoints, setShowpoints] = useState(false);
  const [redeemMessage, setRedeemMessage] = useState("");

  const location = useLocation();

  let drawerWidth = 240;
  const classes = useGetHomeScreenStyles();
  const navigate = useNavigate();
  const { setPayloadsPopupseen, popupseendata } = usePopupseen();
  const { userDetails, activeBrand, setActiveBrand } = useContext(UserContext);
  const [showDrawer, setShowDrawer] = useState(false);
  const [drawerContentRoute, setDrawerContentRoute] = useState("search");
  const [seconds, setSeconds] = useState(0);
  const [selectedOfferIndex, setSelectedOfferIndex] = useState();
  const [redeemedOfferIndexes, setRedeemedOfferIndexes] = useState([]);
  const offerDetailsCardRef = useRef(null);
  const { data, setPayload } = useHome();
  const { setPayloadsPopupseenuser } = usePopupseenuser();
  const {
    barndList,
    brandCount,
    brandpayload1,
    setBrandPayload1,
    setBrandPayload,
    setUpdateBrandFav,
    isBrandLoading,
    setBrandReccurLoad,
  } = useBrand();
  const {
    categoryList,
    setCatPayload,
    setCatPayload1,
    payload1,
    setCatReccurLoad,
  } = useCategory();
  const {
    subCategoryList = [],
    isSubCatLoading,
    setSubCatPayload,
    setSubParam,
    setCatParam,
  } = useSubCategory();

  const homeTabs = useMemo(
    () => [
      { name: "Do you Know", uuid: DO_YOU_KNOW_TAB_UUID },
      ...subCategoryList,
      { name: "Coupons", uuid: QUICK_OFFERS_TAB_UUID },
    ],
    [subCategoryList],
  );
  const activeBrandList = useMemo(
    () => barndList?.filter((brand) => brand?.is_active) ?? [],
    [barndList],
  );

  const {
    mailList,
    mailCount,
    // showpoints, isRedeem, redeemMessage, redeemError,
    mailHTML,
    setMailPayload,
    setUpdateMailFav,
    // setShowpoints,
    setUpdateMailRedeem,
    setMailURL,
    isMailLoading,
    redeemmsg,
    setReccurLoad,
  } = useMail();

  // Calculate total redeemed points and mail count from all mails where is_seen === 'true'
  const { totalRedeemedPoints, totalMailCount, unreadMailCount } = useMemo(
    () => {
      if (!mailList || mailList.length === 0)
        return {
          totalRedeemedPoints: 0,
          totalMailCount: 0,
          unreadMailCount: 0,
        };
      const redeemed = mailList.filter(
        (item) => item?.is_seen === "true" && item?.type === "paid",
      );
      const total = redeemed.reduce((sum, item) => sum + item?.amount, 0);
      return {
        totalRedeemedPoints: total,
        totalMailCount: mailList.length,
        unreadMailCount: mailList.filter((item) => item?.is_seen === "false")
          .length,
      };
    },
    [mailList],
  );
  const [subCatActive, setSubCatActive] = useState("");
  const [subCatActive1, setSubCatActive1] = useState("");
  const { countryList, setCountry } = useCountry();
  const { stateData, setStateData } = useStateData();
  const { countyData, setCountyData } = useCountyData();
  const { cityData, setCityData } = useCityData();
  const [selCountry, setSelCountry] = useState();
  const [selState, setSelState] = useState();
  const [selCounty, setSelCounty] = useState("");
  const [selCity, setSelCity] = useState();
  const [cityactive, setcityactive] = useState("");
  const [offerCard, setOfferCard] = useState({});
  const [selCategory, setSelCategory] = useState("");
  const userPickedCategoryRef = useRef(false);
  const [selBrand, setSelBrand] = useState([]);
  const [numPages, setNumPages] = useState(1);
  const [show, setShow] = useState("");
  const [isAnimate, setIsAnimate] = useState(true);
  const [tabIndex, setTabIndex] = useState(0);
  const [showVideo, setShowVideo] = useState(false);
  const [redeemmsgs, setredeemmsgs] = useState(false);
  const [showLeftDrawer, setShowLeftDrawer] = useState(true);
  const [showRightDrawer, setShowRightDrawer] = useState(false);
  const [locationCheck, setLocationCheck] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams(
    window.location.search,
  );
  const [searchCat, setSearchCat] = useState(searchParams.get("cat"));
  const [searchBrand, setSearchBrand] = useState(searchParams.get("brand"));
  const [searchSubCat, setSearchSubCat] = useState(searchParams.get("sub"));
  const { Popupaddsdata, setPayloads } = usePopAddslist();
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const { Setprofile, Profilelist } = useProfile();
  const { setusermodelpayload } = Useseenmodels();
  const { modeldata, setModelPayloads } = useModellist();
  const [openShow, setOpenShow] = useState(0);
  const removeQueryParams = () => {
    searchParams.delete("cat");
    searchParams.delete("brand");
    searchParams.delete("sub");
    setSearchParams(searchParams);
  };

  useEffect(() => {
    setSearchCat(searchParams.get("cat"));
    setSearchBrand(searchParams.get("brand"));
    setSearchSubCat(searchParams.get("sub"));
  }, [searchParams]);

  const [seen, setseen] = useState("");
  const isOfferContentDrawerActive = drawerContentRoute === "offerCard";
  const {
    doYouKnowData,
    isDoYouKnowLoading,
    doYouKnowError,
    isDoYouKnowConfigured,
  } = useDoYouKnow({ storeUuid: selBrand[0], token: userDetails?.token });
  const {
    data: activeCampaignsData,
    isLoading: isActiveCampaignsLoading,
    isError: isActiveCampaignsError,
  } = useActiveCampaigns({
    token: userDetails?.token,
    limit: 12,
    city: selCity,
  });
  const activeCampaigns = useMemo(
    () => getCollection(activeCampaignsData).slice(0, 12),
    [activeCampaignsData],
  );
  const activeCampaignCount = getTotalCount(
    activeCampaignsData,
    activeCampaigns.length,
  );
  const {
    quickOffersData,
    promotionsData,
    isQuickOffersLoading,
    quickOffersError,
  } =
    useQuickOffers({ storeUuid: selBrand[0], token: userDetails?.token });
  const hasDoYouKnowData = useMemo(() => {
    if (Array.isArray(doYouKnowData?.data))
      return doYouKnowData.data.length > 0;
    if (Array.isArray(doYouKnowData?.items))
      return doYouKnowData.items.length > 0;
    if (Array.isArray(doYouKnowData)) return doYouKnowData.length > 0;
    return Boolean(doYouKnowData);
  }, [doYouKnowData]);
  const Popupaddsdata1 = Popupaddsdata?.data;
  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages);
  }

  // Don't auto-select any store on load
  // useEffect(() => {
  //   if (barndList && barndList?.length > 0) {
  //     onBrandSelect(true, barndList[0]?.uuid);
  //   }
  // }, [barndList]);

  let userdata = JSON.parse(localStorage.getItem("user"));
  const { noticationdata, setPayloadsdata, unread } = Notificationconsumer();

  useEffect(() => {
    setPayloadsdata(userdata?.uuid);
  }, []);

  useEffect(() => {
    if (searchCat) {
      setSelCategory(searchCat);
      setCatParam(searchCat);
    } else if (location?.state?.data?.selCategory) {
      setSelCategory(location?.state?.data?.selCategory);
      setCatParam(location?.state?.data?.selCategory);
    } else if (categoryList?.length > 0 && !userPickedCategoryRef.current) {
      setSelCategory(categoryList[0]?.uuid);
      setCatParam(categoryList[0]?.uuid);
    }
  }, [categoryList, searchCat]);

  useEffect(() => {
    const data = {
      id: userdata?.uuid,
    };
    setPayloads(data);
    Setprofile(userdata?.uuid);
    setModelPayloads(userdata?.uuid);
  }, []);

  useEffect(() => {
    if (Profilelist?.data?.pop_up === false) {
      setShow(true);
    } else if (Profilelist?.data?.pop_up === true) {
      setShow(false);
    }
  }, [Profilelist]);
  const { start, stop } = useInterval((count) => {
    setSeconds(count);
    if (count === 18) {
      setSeconds(0);
      setIsAnimate(true);
      stop();
    }
  });

  useEffect(() => {
    if (!userDetails?.uuid) return;
    // The user has manually picked a city (possibly in a different
    // country/state/county) via the city switcher — don't let this
    // poll-driven effect stomp that choice back to the home address.
    if (cityactive === true) return;
    if (location?.state?.data?.selCountry) {
      setSelCountry(location?.state?.data?.selCountry);
      setSelState(location?.state?.data?.selState);
      setSelCounty(location?.state?.data?.selCounty);
      setSelCity(location?.state?.data?.selCity);
    } else {
      setSelCountry(userDetails?.address?.country || userDetails?.country);
      setSelState(userDetails?.address?.state || userDetails?.state);
      setSelCounty(userDetails?.address?.county || userDetails?.county);
      setSelCity(userDetails?.address?.city || userDetails?.city);
    }
  }, [userDetails, mailList, mailCount, cityactive]);

  const isMobile = window.innerWidth <= 768;

  const carouselContainerStyle = {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    position: "relative",
    width: "100%",
    maxWidth: isMobile ? "100%" : "900px",
    margin: "auto",
    flexDirection: isMobile ? "column" : "row",
    maxHeight: "72vh",
    overflow: "hidden",
    padding: isMobile ? "0 12px" : "0 48px",
  };

  const modalStyles = {
    overlay: {
      position: "fixed",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      background: "rgba(0, 0, 0, 0.5)",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
    content: {
      background: "white",
      padding: "20px",
      borderRadius: "8px",
      position: "relative",
      width: "fit-content",
      maxWidth: "80%",
    },
    closeButton: {
      position: "absolute",
      top: "55px",
      // right: '10px',
      left: "117%",
      background: "none",
      border: "none",
      fontSize: "24px",
      cursor: "pointer",
    },
    Closebutton: {
      position: "absolute",
      top: "10px",
      right: "10px",
      // left: '117%',
      background: "none",
      border: "none",
      fontSize: "30px",
      cursor: "pointer",
    },
    body: {
      textAlign: "center",
    },
    image: {
      maxWidth: "100%",
      maxHeight: "80vh",
      backgroundColor: "black",
      height: "auto",
      objectFit: "contain",
    },
  };

  const imageStyle1 = {
    width: "100%",
    maxWidth: "100%",
    maxHeight: "72vh",
    height: "auto",
    objectFit: "contain",
    display: "block",
    margin: "0 auto",
  };

  const arrowButtonStyle = {
    position: "absolute",
    top: isMobile ? "auto" : "50%",
    bottom: isMobile ? "10px" : "auto",
    transform: isMobile ? "none" : "translateY(-50%)",
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    color: "white",
    border: "none",
    padding: isMobile ? "5px" : "10px",
    cursor: "pointer",
    zIndex: 2,
  };

  const prevButtonStyle = {
    ...arrowButtonStyle,
    left: isMobile ? "10px" : "10px",
  };

  const nextButtonStyle = {
    ...arrowButtonStyle,
    right: isMobile ? "10px" : "10px",
  };

  const image = {
    display: "block",
    maxWidth: "60%",
    // maxHeight: "70%",
    marginLeft: "25%",
    borderRadius: 4,
  };
  const imageStyle = {
    cursor: "pointer", // Ensure the image has a pointer cursor
    // Add other styles as needed
  };
  const handleClose = (item) => {
    setShow(false);

    setPayloadsPopupseen({
      user_uuid: userdata?.uuid,
    });
    setusermodelpayload({
      // uuid
      user_uuid: userdata?.uuid,
      modal_uuid: item,
    });
    Popupaddsdata1.forEach((item) => {
      setPayloadsPopupseenuser({
        // uuid
        user_uuid: userdata?.uuid,
        popup_uuid: item?.uuid,
      });
    });
    setOpenShow(openShow + 1);
  };
  const goToNextAd = (data) => {
    // setCurrentAdIndex((prevIndex) => (prevIndex + 1) % Popupaddsdata1?.length);
    setusermodelpayload({
      // uuid
      user_uuid: userdata?.uuid,
      modal_uuid: data,
    });
  };

  const [mailSubscribeUpdate, setmailSubscribeUpdate] = useState(false);

  useEffect(() => {
    let indexValue = 0;
    // const defBrandPayload = `pagenum=0&limit=${drawerContentRoute === 'search' && showDrawer ? 100 : 12}&user_uuid=${userDetails?.uuid}`
    // setBrandPayload(`${defBrandPayload}&category_uuid=${selCategory ?? ""}&country_uuid=${selCountry}&state_uuid=${selState}&city_uuid=${selCity}&county_uuid=${selCounty}`)
    if (!userDetails?.uuid) return; // wait for user details to load
    if (selCountry === undefined) return; // wait for location to be initialized

    if (subCategoryList && subCategoryList?.length > 0) {
      const isEven = (value) => value.is_mail_available === "true";
      const checkMail = subCategoryList.filter(isEven);
      if (checkMail?.length > 0) {
        subCategoryList &&
          subCategoryList.find((val, undex) => {
            if (searchSubCat !== "") {
              if (searchSubCat === val?.uuid) {
                setSubCatActive(searchSubCat);
                setTabindexs(0);
                const defPayload = `country_uuid=${selCountry}&state_uuid=${selState}&city_uuid=${selCity}&user_uuid=${userDetails?.uuid}&county_uuid=${selCounty}`;
                if (cityactive === true) {
                  setCatPayload(
                    `search=&user_uuid=${userDetails?.uuid === undefined ? "" : userDetails?.uuid}&city_uuid=${selCity}`,
                  );
                  setMailPayload(
                    selBrand.length > 0
                      ? selCategory
                        ? `${defPayload}&category_uuid=${selCategory ?? ""}&brand_uuid=&sub_category_uuid=&type=filter&search=&pagenum=&limit=&seen=${seen}`
                        : `${defPayload}&brand_uuid=${selBrand}&sub_category_uuid=${searchSubCat}&type=filter&search=&pagenum=&limit=&seen=${seen}`
                      : `${defPayload}&sub_category_uuid=${searchSubCat}&category_uuid=${selCategory ?? ""}&type=filter&search=&pagenum=&limit=&seen=${seen}`,
                  );
                } else {
                  // setMailPayload(selBrand.length > 0 ? selCategory ? `${defPayload}&category_uuid=${selCategory ?? ""}&brand_uuid=${selBrand}&sub_category_uuid=${searchSubCat}&seen=${seen}` : `${defPayload}&brand_uuid=${selBrand}&sub_category_uuid=${searchSubCat}&seen=${seen}` : `${defPayload}&sub_category_uuid=${searchSubCat}&category_uuid=${selCategory ?? ""}&search=&pagenum=&limit=&seen=${seen}`);
                  setCatPayload(
                    `search=&user_uuid=${userDetails?.uuid === undefined ? "" : userDetails?.uuid}`,
                  );
                }
              }
            } else if (val.is_mail_available === "true" && indexValue === 0) {
              indexValue = indexValue + 1;
              setSubCatActive(val?.uuid || subCategoryList[0].uuid);
              setTabindexs(0);
              if (cityactive === true) {
                // ${selBrand}
                // ${val?.uuid || subCategoryList[0].uuid}
                const defPayload = `country_uuid=${selCountry}&state_uuid=${selState}&city_uuid=${selCity}&user_uuid=${userDetails?.uuid}&county_uuid=${selCounty}`;
                setCatPayload(
                  `search=&user_uuid=${userDetails?.uuid === undefined ? "" : userDetails?.uuid}&city_uuid=${selCity}`,
                );
                setMailPayload(
                  selBrand.length > 0
                    ? selCategory
                      ? `${defPayload}&category_uuid=${selCategory ?? ""}&brand_uuid=&sub_category_uuid=&type=filter&search=&pagenum=&limit=&seen=${seen}`
                      : `${defPayload}&brand_uuid=${selBrand}&sub_category_uuid=${val?.uuid || subCategoryList[0].uuid}&type=filter&search=&pagenum=&limit=&seen=${seen}`
                    : `${defPayload}&sub_category_uuid=${val?.uuid || subCategoryList[0].uuid}&category_uuid=${selCategory ?? ""}&type=filter&search=&pagenum=&limit=&seen=${seen}`,
                );
              } else {
                const defPayload = `country_uuid=${selCountry}&state_uuid=${selState}&city_uuid=${selCity}&user_uuid=${userDetails?.uuid}&county_uuid=${selCounty}`;
                setCatPayload(
                  `search=&user_uuid=${userDetails?.uuid === undefined ? "" : userDetails?.uuid}`,
                );
                setMailPayload(
                  selBrand.length > 0
                    ? selCategory
                      ? `${defPayload}&category_uuid=${selCategory ?? ""}&brand_uuid=${selBrand}&sub_category_uuid=${val?.uuid || subCategoryList[0].uuid}&seen=${seen}`
                      : `${defPayload}&brand_uuid=${selBrand}&sub_category_uuid=${val?.uuid || subCategoryList[0].uuid}&seen=${seen}`
                    : `${defPayload}&sub_category_uuid=${val?.uuid || subCategoryList[0].uuid}&category_uuid=${selCategory ?? ""}&search=&pagenum=&limit=&seen=${seen}`,
                );
              }
            }
          });
      } else {
        setSubCatActive(subCategoryList[0].uuid);
        setTabindexs(0);
        const defPayload = `country_uuid=${selCountry}&state_uuid=${selState}&city_uuid=${selCity}&user_uuid=${userDetails?.uuid}&county_uuid=${selCounty}`;
        if (cityactive === true) {
          setMailPayload(
            selBrand.length > 0
              ? selCategory
                ? `${defPayload}&category_uuid=${selCategory ?? ""}&brand_uuid=&sub_category_uuid=&type=filter&search=&pagenum=&limit=&seen=${seen}`
                : `${defPayload}&brand_uuid=${selBrand}&sub_category_uuid=${subCategoryList[0].uuid}&type=filter&search=&pagenum=&limit=&seen=${seen}`
              : `${defPayload}&sub_category_uuid=${subCategoryList[0].uuid}&category_uuid=${selCategory ?? ""}&type=filter&search=&pagenum=&limit=&seen=${seen}`,
          );
          setCatPayload(
            `search=&user_uuid=${userDetails?.uuid === undefined ? "" : userDetails?.uuid}&city_uuid=${selCity}`,
          );
        } else {
          setMailPayload(
            selBrand.length > 0
              ? selCategory
                ? `${defPayload}&category_uuid=${selCategory ?? ""}&brand_uuid=${selBrand}&sub_category_uuid=${subCategoryList[0].uuid}&seen=${seen}`
                : `${defPayload}&brand_uuid=${selBrand}&sub_category_uuid=${subCategoryList[0].uuid}&seen=${seen}`
              : `${defPayload}&sub_category_uuid=${subCategoryList[0].uuid}&category_uuid=${selCategory ?? ""}&search=&pagenum=&limit=&seen=${seen}`,
          );
          setCatPayload(
            `search=&user_uuid=${userDetails?.uuid === undefined ? "" : userDetails?.uuid}`,
          );
        }
      }
    }
  }, [
    subCategoryList,
    selBrand,
    selCategory,
    searchSubCat,
    mailSubscribeUpdate,
  ]);

  useEffect(() => {
    // Wait until userDetails is loaded AND location state is initialized
    if (!userDetails?.uuid) return;
    if (selCountry === undefined) return; // location-setter hasn't run yet

    // if (cityactive === true) {
    if (cityactive === true) {
      setSubCatPayload(
        `country_uuid=${selCountry ? selCountry : ""}&state_uuid=${selState ? selState : ""}&city_uuid=${selCity ? selCity : ""}&county_uuid=${selCounty ? selCounty : ""}&search=`,
      );
      setPayload(`page_name=home`);
      setBrandPayload(
        `pagenum=0&limit=${drawerContentRoute === "search" && showDrawer ? 100 : 16}&user_uuid=${userDetails?.uuid}&category_uuid=${selCategory ? selCategory : ""}&country_uuid=${selCountry}&state_uuid=${selState}&city_uuid=${selCity}&county_uuid=${selCounty}&brand_uuid=`,
      );
      // ${selBrand ? selBrand : ''}
      setCatPayload(
        `search=&user_uuid=${userDetails?.uuid === undefined ? "" : userDetails?.uuid}&city_uuid=${selCity}`,
      );
      setCountry(`page=0&limit=10&search=UnitedStates`);
    } else {
      setSubCatPayload(
        `country_uuid=${selCountry ? selCountry : ""}&state_uuid=${selState ? selState : ""}&city_uuid=${selCity ? selCity : ""}&county_uuid=${selCounty ? selCounty : ""}&search=`,
      );
      setPayload(`page_name=home`);
      setBrandPayload(
        `pagenum=0&limit=${drawerContentRoute === "search" && showDrawer ? 100 : 16}&user_uuid=${userDetails?.uuid}&category_uuid=${selCategory ? selCategory : ""}&country_uuid=${selCountry}&state_uuid=${selState}&city_uuid=${selCity}&county_uuid=${selCounty}&brand_uuid=${selBrand ? selBrand : ""}`,
      );
      setCatPayload(
        `search=&user_uuid=${userDetails?.uuid === undefined ? "" : userDetails?.uuid}`,
      );
      setCountry(`page=0&limit=10&search=UnitedStates`);
    }
    // if (subCatActive && (selCountry || selState || selCounty || selCity)) setMailPayload(`country_uuid=${selCountry}&brand_uuid=${selBrand}&state_uuid=${selState}&city_uuid=${selCity}&sub_category_uuid=${subCatActive ?? ""}&user_uuid=${userDetails?.uuid}&county_uuid=${selCounty}&category_uuid=${selCategory ?? ""}&type=filter`);
  }, [
    selCountry,
    selState,
    selCounty,
    selCity,
    selCategory,
    userDetails,
    mailSubscribeUpdate,
  ]);

  const onTabChane = (sub_category_uuid, tabsss) => {
    if (sub_category_uuid === DO_YOU_KNOW_TAB_UUID) {
      return;
    }
    if (sub_category_uuid === QUICK_OFFERS_TAB_UUID) {
      return;
    }
    // setSearchSubCat('')
    setSubCatActive(sub_category_uuid);
    const defUrl = `country_uuid=${selCountry}&state_uuid=${selState}&city_uuid=${selCity}&sub_category_uuid=${sub_category_uuid}&user_uuid=${userDetails?.uuid}&county_uuid=${selCounty}`;
    setMailPayload(
      selBrand?.length > 0
        ? `${defUrl}&brand_uuid=${selBrand}&category_uuid=${selCategory ?? ""}&seen=${seen}`
        : selCategory
          ? `${defUrl}&category_uuid=${selCategory ?? ""}&seen=${seen}`
          : `${defUrl}`,
    );
  };

  useEffect(() => {
    if (isOfferContentDrawerActive) {
      // start();
    }
  }, [isOfferContentDrawerActive]);

  // useEffect(() => {
  //   if (isRedeem) {
  //     setShowDrawer(true)
  //   }
  // }, [redeemError, isRedeem])

  useEffect(() => {
    if (!showDrawer) {
      setBrandPayload(
        `pagenum=0&limit=6&user_uuid=${userDetails?.uuid}&category_uuid=${selCategory ? selCategory : ""}&country_uuid=${selCountry}&state_uuid=${selState}&city_uuid=${selCity}&county_uuid=${selCounty}&brand_uuid=${selBrand ? selBrand : ""}`,
      );
    }
  }, [showDrawer]);
  const handleNavLinksClick = (route, item) => {
    const isRedeemed = item?.is_seen === "true";
    setBrandPayload(
      `pagenum=0&limit=${drawerContentRoute === "search" && showDrawer ? 100 : 6}&user_uuid=${userDetails?.uuid}&category_uuid=${selCategory ? selCategory : ""}&country_uuid=${selCountry}&state_uuid=${selState}&city_uuid=${selCity}&county_uuid=${selCounty}&brand_uuid=${selBrand ? selBrand : ""}`,
    );
    setCatPayload(
      `search=&user_uuid=${userDetails?.uuid === undefined ? "" : userDetails?.uuid}`,
    );

    if (item?.mime_type === "text/html") {
      const url = item?.image_url?.split("/");
      setMailURL({ html_url: url.slice(-1)[0] });
    }

    // setSeconds(1)

    setIsAnimate(false);
    setOfferCard(item);

    if (route === "offerCard") {
      if (item?.type !== "regular" && !isRedeemed) {
        RedeemApiCall(
          {
            user_uuid: userDetails?.uuid,
            mail_uuid: item?.uuid,
          },
          {
            onSuccess: () => {
              setDrawerContentRoute(route);
              setShowDrawer(true);
            },
          },
        );
      } else {
        setDrawerContentRoute(route);
        setShowDrawer(true);
      }
    } else if (route === "location" || route === "search") {
      setDrawerContentRoute(route);
      setShowDrawer(true);
      setBrandPayload(
        `pagenum=0&limit=${route === "search" ? 100 : 6}&user_uuid=${userDetails?.uuid}&category_uuid=${selCategory ? selCategory : ""}&country_uuid=${selCountry}&state_uuid=${selState}&city_uuid=${selCity}&county_uuid=${selCounty}&brand_uuid=${selBrand ? selBrand : ""}`,
      );
    }
    if (route !== "search" && item?.type === "regular") {
      RedeemApiCall({
        user_uuid: userDetails?.uuid,
        mail_uuid: item?.uuid,
      });
    }
  };
  const toggleDrawer = (event) => {
    if (
      (event.type === "keydown" &&
        (event.key === "Tab" || event.key === "Shift")) ||
      isOfferContentDrawerActive
    ) {
      return;
    }
    setShowDrawer(false);
  };

  const onFavouriteToggle = (e, brand_uuid) => {
    e.preventDefault();
    setUpdateBrandFav({
      user_uuid: userDetails?.uuid,
      brand_uuid: brand_uuid,
    });
  };

  const onFavouriteMailToggle = (e, mail_uuid, item) => {
    e.preventDefault();
    if (locationCheck) setLocationCheck(false);
    if (item?.city_uuid !== "") {
      if (
        item?.country_uuid === userDetails?.address?.country &&
        item?.state_uuid === userDetails?.address?.state &&
        item?.county_uuid === userDetails?.address?.county &&
        item?.city_uuid === userDetails?.address?.city
      ) {
        setUpdateMailFav({
          user_uuid: userDetails?.uuid,
          mail_uuid: mail_uuid,
        });
      } else {
        setLocationCheck(true);
      }
    } else if (item?.county_uuid !== "") {
      if (
        item?.country_uuid === userDetails?.address?.country &&
        item?.state_uuid === userDetails?.address?.state &&
        item?.county_uuid === userDetails?.address?.county
      ) {
        setUpdateMailFav({
          user_uuid: userDetails?.uuid,
          mail_uuid: mail_uuid,
        });
      } else {
        setLocationCheck(true);
      }
    } else if (item?.state_uuid !== "") {
      if (
        item?.country_uuid === userDetails?.address?.country &&
        item?.state_uuid === userDetails?.address?.state
      ) {
        setUpdateMailFav({
          user_uuid: userDetails?.uuid,
          mail_uuid: mail_uuid,
        });
      } else {
        setLocationCheck(true);
      }
    } else if (item?.country_uuid !== "") {
      if (item?.country_uuid === userDetails?.address?.country) {
        setUpdateMailFav({
          user_uuid: userDetails?.uuid,
          mail_uuid: mail_uuid,
        });
      } else {
        setLocationCheck(true);
      }
    }
  };

  const onChangeHandler = (id, val) => {
    if (id === "country") {
      setSelCountry(val);
      setStateData(val);
      setSelState("");
      setSelCity("");
      setSelCounty("");
    }
    if (id === "state") {
      setSelState(val);
      setSelCounty("");
      setSelCity("");
      setCountyData(val);
    }
    if (id === "county") {
      setSelCounty(val);
      setSelCity("");
      setCityData(val);
    }
    if (id === "city") {
      setSelCity(val);
      // Mark the city as a manual override so the userDetails/poll-driven
      // effect above doesn't reset it back to the home address city.
      setcityactive(true);
    }
  };
  const [isFirstSelection, setIsFirstSelection] = useState(true);

  const onChangeCategoryHandler = (ss, value) => {
    userPickedCategoryRef.current = true;
    const isExist = selCategory === value ? true : false;
    setSelBrand([]);
    setSearchSubCat("");
    setSelCategory((prev) => (prev !== value ? value : prev));
    setSubParam("");
    if (isFirstSelection) {
      setCatParam(value);
      setIsFirstSelection(false);
    } else {
      setCatParam((prev) => (prev !== value ? value : prev));
    }
    if (showDrawer) setShowDrawer(false);
    const defBrandPayload = `pagenum=0&limit=${drawerContentRoute === "search" && showDrawer ? 100 : 6}&user_uuid=${userDetails?.uuid}`;
    const defPayload = `country_uuid=${selCountry}&state_uuid=${selState}&city_uuid=${selCity}&sub_category_uuid=${subCatActive ?? ""}&user_uuid=${userDetails?.uuid}&county_uuid=${selCounty}`;
    // setMailPayload(!isExist ? `${defPayload}&category_uuid=${value}&brand_uuid=${selBrand}` : `${defPayload}&brand_uuid=${selBrand}`)
    // setBrandPayload(!isExist ? `${defBrandPayload}&category_uuid=${value}&country_uuid=${selCountry}&state_uuid=${selState}&city_uuid=${selCity}&county_uuid=${selCounty}` : `${defBrandPayload}&country_uuid=${selCountry}&state_uuid=${selState}&city_uuid=${selCity}&county_uuid=${selCounty}&category_uuid=${value}`)
    // setBrandPayload(`pagenum=0&limit=${drawerContentRoute === 'search' && showDrawer ? 100 : 6}&user_uuid=${userDetails?.uuid}&category_uuid=${value}&country_uuid=${selCountry}&state_uuid=${selState}&city_uuid=${selCity}&county_uuid=${selCounty}&brand_uuid=${selBrand ? selBrand : ''}`);
    // setSubCatPayload(`country_uuid=${selCountry}&state_uuid=${selState}&city_uuid=${selCity}&county_uuid=${selCounty}&search=`);
    // setCatPayload(`search=&user_uuid=${userDetails?.uuid === undefined ? "" : userDetails?.uuid}`);
    if (cityactive === true) {
      setMailPayload(
        !isExist
          ? `${defPayload}&brand_uuid=&type=filter&search=&pagenum=&limit=`
          : `${defPayload}&brand_uuid=&type=filter&search=&pagenum=&limit=`,
      );
      setBrandPayload(
        `pagenum=0&limit=${drawerContentRoute === "search" && showDrawer ? 100 : 16}&user_uuid=${userDetails?.uuid}&category_uuid=${value}&country_uuid=${selCountry}&state_uuid=${selState}&city_uuid=${selCity}&county_uuid=${selCounty}&brand_uuid=${selBrand ? selBrand : ""}&type=filter`,
      );
      setSubCatPayload(
        `country_uuid=${selCountry}&state_uuid=${selState}&city_uuid=${selCity}&county_uuid=${selCounty}&search=&type=filter`,
      );
      setCatPayload(
        `search=&user_uuid=${userDetails?.uuid === undefined ? "" : userDetails?.uuid}&user_uuid=${userDetails?.uuid}`,
      );
    } else {
      setMailPayload(
        !isExist
          ? `${defPayload}&category_uuid=${value}&brand_uuid=`
          : `${defPayload}&brand_uuid=&search=&pagenum=&limit=`,
      );
      setBrandPayload(
        !isExist
          ? `${defBrandPayload}&category_uuid=${value}&country_uuid=${selCountry}&state_uuid=${selState}&city_uuid=${selCity}&county_uuid=${selCounty}`
          : `${defBrandPayload}&country_uuid=${selCountry}&state_uuid=${selState}&city_uuid=${selCity}&county_uuid=${selCounty}&category_uuid=${value}`,
      );
      setBrandPayload(
        `pagenum=0&limit=${drawerContentRoute === "search" && showDrawer ? 100 : 16}&user_uuid=${userDetails?.uuid}&category_uuid=${value}&country_uuid=${selCountry}&state_uuid=${selState}&city_uuid=${selCity}&county_uuid=${selCounty}&brand_uuid=${selBrand ? selBrand : ""}`,
      );
      setSubCatPayload(
        `country_uuid=${selCountry}&state_uuid=${selState}&city_uuid=${selCity}&county_uuid=${selCounty}&search=`,
      );
      setCatPayload(
        `search=&user_uuid=${userDetails?.uuid === undefined ? "" : userDetails?.uuid}`,
      );
    }

    removeQueryParams();
  };

  useEffect(() => {
    const data = payload1 + "dd";
    setCatPayload1(data);
    const data1 = brandpayload1 + "dd";
    setBrandPayload1(data1);
    if (cityactive !== true) {
      setCatPayload(
        `search=&user_uuid=${userDetails?.uuid === undefined ? "" : userDetails?.uuid}&city_uuid=${selCity}`,
      );
      // setBrandPayload removed — payload effect handles brand initialization with proper guards.
      // Calling it here fires with undefined location data, causing an immediate "Coming Soon" flash.
    }

    if (categoryList?.length > 0) {
      setSelCategory(selCategory ? selCategory : categoryList[0]?.uuid);
    }
    // onBrandSelect(true, barndList[0]?.uuid)
  }, [isRedeem]);

  useEffect(() => {
    if (searchBrand) {
      const brand = [searchBrand];
      setSelBrand([...brand]);
      setTimeout(function () {
        onBrandSelect(true, searchBrand);
      }, 800);
    } else if (location?.state) {
      const brand = [location?.state?.id];
      setSelBrand([...brand]);
      setTimeout(function () {
        onBrandSelect(true, location?.state?.id);
      }, 800);
    } else if (activeBrand && activeBrand?.length > 0) {
      setSelBrand([...activeBrand]);
      setTimeout(function () {
        onBrandSelect(true, activeBrand[0]);
      }, 800);
      // Consume it — otherwise this stays set for the rest of the SPA
      // session and blocks the default-category auto-select on every future
      // visit to /home, since selBrand never goes back to empty on its own.
      setActiveBrand([]);
    } else if (selBrand && selBrand?.length > 0) {
      setTimeout(function () {
        onBrandSelect(true, selBrand[0]);
      }, 800);
    }
  }, [selCountry, searchBrand]);

  const onBrandSelect = (e, brandId, brandDetails) => {
    const brand = e ? [brandId] : selBrand.filter((el) => el !== brandId);
    setSelBrand([...brand]);
    // TanStack Query automatically fetches/clears doYouKnow and quickOffers
    // based on selBrand[0] changing — no manual load/reset needed.
    setSubParam([...brand]);
    if (searchCat) {
      setCatParam(searchCat ? searchCat : "");
    } else {
      setCatParam(selCategory ? selCategory : "");
    }
    setTimeout(mailFilter, 1000);
  };

  useEffect(() => {
    if (searchBrand || location?.state?.id || activeBrand?.length > 0) return;
    if (selBrand?.length > 0) return;
    if (activeBrandList.length === 0) return;

    const [firstBrand] = activeBrandList;
    onBrandSelect(true, firstBrand?.uuid, firstBrand);
  }, [
    activeBrand,
    activeBrandList,
    location?.state?.id,
    searchBrand,
    selBrand,
  ]);

  const mailFilter = () => {
    if (mailList.length > 0) {
      const id = mailList[0]?.deals_type[0]?.uuid;
      const index = subCategoryList.findIndex((el) => el.uuid === id);
    }
  };

  const DefaultAddress = () => {
    setStateData(userDetails?.address?.country);
    // Resetting to the default address always wins over a manual city
    // override — clear the flag so the home city sticks going forward.
    setcityactive(false);
    if (userDetails?.address?.city != selCity) {
      setSelCity(userDetails?.address?.city);
    }
    if (userDetails?.address?.state != selState) {
      setCountyData(userDetails?.address?.state);
      setSelState(userDetails?.address?.state);
    }
    if (userDetails?.address?.county != selCounty) {
      setCityData(userDetails?.address?.county);
      setSelCounty(userDetails?.address?.county);
    }
  };
  const [currentIndex, setCurrentIndex] = useState(0);

  const [currentIndex1, setCurrentIndex1] = useState(0);
  const currentCard = mailList[currentIndex];
  const [mailscroll, setmailscroll] = useState(false);

  const nextImage = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % mailList.length);
    setmailscroll(true);
    const currentCard = mailList[currentIndex + 1];
    if (currentCard?.type !== "regular" && currentCard?.is_seen !== "true") {
      RedeemApiCall({
        user_uuid: userDetails?.uuid,
        mail_uuid: currentCard?.uuid,
      });
    }
    setredeemmsgs(currentCard?.is_seen);

    setTimeout(() => {
      setredeemmsgs(false);
    }, 4500);

    // currentIndex
  };
  const [redeemtoast, setredeemtoast] = useState(true);
  const prevImage = () => {
    setCurrentIndex(
      (prevIndex) => (prevIndex - 1 + mailList.length) % mailList.length,
    );
    setmailscroll(true);
    const currentCard = mailList[currentIndex - 1];
    if (currentCard?.type !== "regular" && currentCard?.is_seen !== "true") {
      RedeemApiCall({
        user_uuid: userDetails?.uuid,
        mail_uuid: currentCard?.uuid,
      });
    }
    setredeemmsgs(currentCard?.is_seen);
    setTimeout(() => {
      setredeemmsgs(false);
    }, 4500);
  };

  const [open1, setOpen1] = useState(false);

  const handleClose1 = () => {
    setOpen1(false);
  };
  const handleClickOpen1 = (event) => {
    // sethistoryData(event)
    setOpen1(true);
  };

  const stories2 = Popupaddsdata1?.map((item, index) => ({
    content: ({ action, isPaused }) => (
      <div style={imageStyle} key={index}>
        <img style={image} src={item?.image} alt={`Story ${index}`} />
      </div>
    ),
  }));

  const handleStoryStart = (data1, index) => {
    // if (Popupaddsdata) {

    const data = {
      id: userdata?.uuid,
      indexId: index,
    };
    setPayloads(data);
    setPayloadsPopupseen({
      user_uuid: userdata?.uuid,
    });
    setPayloadsPopupseenuser({
      user_uuid: userdata?.uuid,
      popup_uuid: data1,
    });
    // }
  };
  const handleClick1 = (index) => {
    const data = {
      id: userdata?.uuid,
      indexId: index,
    };
    setPayloads(data);
    setOpen1(false);
  };

  const DrawerLocationCardContent = () => (
    <>
      <div
        css={[classes.locationDetailsContentWrapper]}
        ref={offerDetailsCardRef}
      >
        <Dropdown
          label={"Country"}
          component={"autocomplete"}
          lists={countryList}
          value={selCountry}
          renderKey={"name"}
          renderValue={"uuid"}
          onChange={(e, value) => onChangeHandler("country", value)}
        />
        <Dropdown
          label={"State"}
          component={"autocomplete"}
          lists={stateData}
          value={selState}
          renderKey={"name"}
          renderValue={"uuid"}
          onChange={(e, value) => onChangeHandler("state", value)}
        />
        <Dropdown
          label={"County"}
          component={"autocomplete"}
          lists={countyData}
          value={selCounty}
          renderKey={"name"}
          renderValue={"uuid"}
          onChange={(e, value) => onChangeHandler("county", value)}
        />
        <Dropdown
          label={"City"}
          component={"autocomplete"}
          lists={cityData}
          value={selCity}
          renderKey={"name"}
          renderValue={"uuid"}
          onChange={(e, value) => onChangeHandler("city", value)}
        />
      </div>
      {(userDetails?.address?.city !== selCity ||
        userDetails?.address?.county !== selCounty ||
        userDetails?.address?.state !== selState) && (
        <div
          css={[classes.locationDetailsContentWrapper]}
          ref={offerDetailsCardRef}
        >
          <button css={[classes.buttons]} onClick={() => DefaultAddress()}>
            Change to Default Address
          </button>
        </div>
      )}
    </>
  );

  const DrawerOfferCardContent = () => (
    <div css={classes.offerDetailsContentWrapper} ref={offerDetailsCardRef}>
      {currentCard?.type === "paid" && currentCard?.is_seen === "false" && (
        <div id="backbutton">
          <IconButton
            aria-label="back"
            size="medium"
            css={classes.backArrow}
            onClick={(e) => {
              setDrawerContentRoute("search");
              setShowDrawer(false);
              setShowVideo(false);
              setShowpoints(false);
              setredeemtoast(false);
            }}
          >
            <ArrowBackIosIcon /> Back
          </IconButton>
        </div>
      )}
      {currentCard?.type === "paid" && currentCard?.is_seen === "true" && (
        <IconButton
          aria-label="back"
          size="medium"
          css={classes.backArrow}
          onClick={(e) => {
            setShowDrawer(false);
            setShowVideo(false);
          }}
        >
          <ArrowBackIosIcon /> Back
        </IconButton>
      )}

      {offerCard?.type === "regular" && (
        <IconButton
          aria-label="back"
          size="medium"
          css={classes.backArrow}
          onClick={(e) => {
            setShowDrawer(false);
            setShowVideo(false);
          }}
        >
          <ArrowBackIosIcon /> Back
        </IconButton>
      )}
      <div css={classes.timerWrapper}>
        <div
          id="redeemMessage"
          style={{ marginLeft: "-90px", display: "none" }}
        >
          {currentCard?.type === "paid" && currentCard?.is_seen === "false" && (
            <div className={classes.progress} style={{ position: "relative" }}>
              <FontAwesomeIcon
                icon={faSpinner}
                className={
                  isAnimate ? "fa-1x" : `fa-pulse fa-spin-reverse fa-1x`
                }
                color="#1890ff"
              />
              <Typography
                variant="caption"
                component="div"
                color="text.secondary"
                style={{ position: "absolute", top: "20px", left: "14px" }}
              >
                <div
                  style={{
                    marginLeft: "10px",
                    marginTop: "-18px",
                    whiteSpace: "nowrap",
                    textOverflow: "ellipsis",
                    overflow: " hidden",
                  }}
                >
                  {/* <p>{`${(seconds === 1 ? "Please wait, While your mail is being Redeemed ...." : "Please wait, While your mail is being Redeemed ....")}`}</p> */}
                  <p>{`Please wait, While your mail is being Redeemed ....`}</p>
                </div>
              </Typography>
            </div>
          )}
        </div>
      </div>
      {/* <Typography css={classes.subText}>
        {offerCard?.message}
      </Typography> */}
      <div
        css={classes.subText}
        dangerouslySetInnerHTML={{
          __html:
            mailscroll === true
              ? currentCard?.message || ""
              : currentCard?.message || "",
        }}
      />
      <div>
        {currentCard?.video_url ? (
          <div>
            <VideoPlayer
              url={currentCard?.video_url}
              width="100%"
              height="480px"
            />
          </div>
        ) : null}
      </div>

      <div style={carouselContainerStyle}>
        {currentIndex !== 0 && (
          <button
            onClick={prevImage}
            style={prevButtonStyle}
            disabled={currentIndex === 0}
          >
            {"<"}
          </button>
        )}
        {currentCard?.mime_type === "text/html" && (
          <div
            style={{
              width: "100%",
              maxWidth: "100%",
              maxHeight: "72vh",
              margin: "0 auto",
              overflow: "auto",
            }}
            dangerouslySetInnerHTML={{ __html: mailHTML }}
          />
        )}
        {/* {currentCard?.mime_type === 'application/pdf' && (
          <Document file={currentCard?.image_url} onLoadSuccess={onDocumentLoadSuccess}>
            <Page pageNumber={numPages} />
          </Document>
        )} */}
        {currentCard?.mime_type === "application/pdf" && (
          <div
            style={{
              border: "1px solid rgba(0, 0, 0, 0.3)",
              width: "100%",
              maxWidth: "100%",
              height: "72vh",
            }}
          >
            <Viewer fileUrl={currentCard?.image_url}></Viewer>
          </div>
        )}
        {currentCard?.mime_type !== "text/html" &&
          currentCard?.mime_type !== "application/pdf" && (
            <>
              {currentCard?.image_url === null ? (
                <span>No File Available</span>
              ) : (
                <img style={imageStyle1} src={currentCard?.image_url} alt="" />
              )}
            </>
          )}
        {currentIndex !== mailList.length - 1 && (
          <button onClick={nextImage} style={nextButtonStyle}>
            {">"}
          </button>
        )}
      </div>
    </div>
  );

  const renderDrawerContent = () => {
    switch (drawerContentRoute) {
      case "search":
        return (
          <DrawerSearchContent
            classes={classes}
            brandList={barndList}
            mailList={mailList}
            categoryList={categoryList}
            onFavouriteToggle={onFavouriteToggle}
            onClose={toggleDrawer}
            onCatSelect={onChangeCategoryHandler}
            onSelect={onBrandSelect}
            selBrand={selBrand}
            showDrawer={() => setShowDrawer(false)}
            onFavouriteMailToggle={onFavouriteMailToggle}
            onUnsubscribeMail={unSubscribeMail}
            onOfferCardClick={(_item, idx) => {
              setCurrentIndex(idx);
              setShowVideo(true);
              setSelectedOfferIndex(idx);
              handleNavLinksClick("offerCard", _item);
            }}
            subscribeshow={subscribeshow}
            setSubscribeShow={setSubscribeShow}
          />
        );

      case "location":
        return DrawerLocationCardContent();

      case "offerCard":
        return DrawerOfferCardContent();
    }
  };

  const onDrawerHandler = (e) => {
    e.preventDefault();
    setShowLeftDrawer(!showLeftDrawer);
    drawerWidth = 0;
    // onChangeCategoryHandler(selCategory ? selCategory : '');
  };

  const onDrawerNotification = (e) => {
    e.preventDefault();
    removeQueryParams();
    setShowRightDrawer(!showRightDrawer);
  };

  const handleClickAway = () => {
    setShowRightDrawer(false);
  };
  // alert(showRightDrawer)
  const Allarray = [{ name: "All", uuid: "" }];

  const [tabIndexs, setTabindexs] = useState(0);
  const [change, setchange] = useState(false);
  const [checkseen, setCheckseen] = useState(false);

  const activefunct = (data) => {
    if (data === false) {
      setCheckseen(true);
      setseen("no");
      const defPayload = `country_uuid=${selCountry}&state_uuid=${selState}&city_uuid=${selCity}&user_uuid=${userDetails?.uuid}&county_uuid=${selCounty}`;
      setMailPayload(
        selBrand.length > 0
          ? selCategory
            ? `${defPayload}&category_uuid=${selCategory ?? ""}&brand_uuid=${selBrand}&sub_category_uuid=${subCatActive ?? ""}&seen=no`
            : `${defPayload}&brand_uuid=${selBrand}&sub_category_uuid=${subCatActive ?? ""}&seen=no`
          : `${defPayload}&sub_category_uuid=${subCatActive ?? ""}&category_uuid=${selCategory ?? ""}&search=&seen=no`,
      );
    } else {
      setCheckseen(false);
      setseen("");
      const defPayload = `country_uuid=${selCountry}&state_uuid=${selState}&city_uuid=${selCity}&user_uuid=${userDetails?.uuid}&county_uuid=${selCounty}`;
      setMailPayload(
        selBrand.length > 0
          ? selCategory
            ? `${defPayload}&category_uuid=${selCategory ?? ""}&brand_uuid=${selBrand}&sub_category_uuid=${subCatActive ?? ""}&seen=''`
            : `${defPayload}&brand_uuid=${selBrand}&sub_category_uuid=${subCatActive ?? ""}&seen=''`
          : `${defPayload}&sub_category_uuid=${subCatActive ?? ""}&category_uuid=${selCategory ?? ""}&search=&seen=''`,
      );
    }
    // setseen()
  };

  const initialItemsToShow = 5;
  const [notifications, setNotifications] = useState();
  const [itemsToShow, setItemsToShow] = useState(initialItemsToShow);

  const navigationView = (link) => {
    navigate(link);
    // window.location.reload(false)
  };
  const NotificationUpdateseen = (notifiid) => {
    const payload = {
      notify_uuid: notifiid,
    };
    axios
      .put(`${baseUrl}/notification/update/seen`, payload, {
        headers: {
          "x-auth-token": userdata && userdata?.token,
        },
      })
      .then((res) => {
        // console.log(res)
      })
      .catch((err) => {
        // console.log(err)
      });
  };

  const handleRedeem = () => {
    const messageDiv = document.getElementById("redeemMessage");
    if (messageDiv) {
      messageDiv.style.display = "block";

      // Hide the message after 15 seconds
      setTimeout(() => {
        messageDiv.style.display = "none";
      }, 15000);
    }
  };
  const handleBackButtonShow = () => {
    const messageDiv = document.getElementById("backbutton");
    if (messageDiv) {
      messageDiv.style.display = "none";

      // Hide the message after 15 seconds
      setTimeout(() => {
        messageDiv.style.display = "block";
      }, 15000);
    }
  };

  useEffect(() => {
    handleRedeem();
    handleBackButtonShow();
  }, []);

  const [subscribeshow, setSubscribeShow] = useState(false);
  const unSubscribeMail = (dataSub) => {
    const payload = {
      mail_uuid: dataSub?.uuid,
      user_uuid: userDetails?.uuid,
    };
    axios
      .put(`${baseUrl}/mail/unsubscribe`, payload, {
        headers: {
          "x-auth-token": userDetails?.token,
        },
      })
      .then((res) => {
        setSubscribeShow(false);
        setmailSubscribeUpdate(mailSubscribeUpdate ? false : true);
        setTimeout(() => {
          const data = payload1 + String(mailSubscribeUpdate);
          setCatPayload1(data);
        }, 1000);

        setTimeout(() => {
          const defUrl = `country_uuid=${selCountry}&state_uuid=${selState}&city_uuid=${selCity}&sub_category_uuid=${subCatActive ?? ""}&user_uuid=${userDetails?.uuid}&county_uuid=${selCounty}`;
          setMailPayload(
            selBrand?.length > 0
              ? `${defUrl}&brand_uuid=${selBrand}&category_uuid=${selCategory ?? ""}&seen=${seen}`
              : selCategory
                ? `${defUrl}&category_uuid=${selCategory ?? ""}&search=&pagenum=&limit=&seen=${seen}`
                : `${defUrl}`,
          );
        }, 1000);
        // const defPayload = `country_uuid=${selCountry}&state_uuid=${selState}&city_uuid=${selCity}&user_uuid=${userDetails?.uuid}&county_uuid=${selCounty}`;
        // setMailPayload(selBrand.length > 0 ? selCategory ? `${defPayload}&category_uuid=${selCategory ?? ""}&brand_uuid=${selBrand}&sub_category_uuid=${subCatActive ?? ""}&seen=''` : `${defPayload}&brand_uuid=${selBrand}&sub_category_uuid=${subCatActive ?? ""}&seen=''` : `${defPayload}&sub_category_uuid=${subCatActive ?? ""}&category_uuid=${selCategory ?? ""}&search=&seen=${checkseen ? 'no' : ''}`);
      })
      .catch((err) => {
        // console.log(err)
      });
  };

  const RedeemApiCall = (updateMailRedeem, opts = {}) => {
    // const defPayload = `country_uuid=${selCountry}&state_uuid=${selState}&city_uuid=${selCity}&sub_category_uuid=${subCatActive ?? ""}&category_uuid=${selCategory ?? ""}&user_uuid=${userDetails?.uuid}&county_uuid=${selCounty}`
    // setMailPayload(`${defPayload}&brand_uuid=&search=&pagenum=&limit=`);
    setReccurLoad(false);
    setCatReccurLoad(false);
    setBrandReccurLoad(false);
    const headers = new Headers();
    headers.append("Content-Type", "application/json");
    appendAuthToken(headers, userDetails?.token);

    const params = JSON.stringify(updateMailRedeem);

    const requestOptions = {
      method: "PUT",
      headers: headers,
      body: params,
      redirect: "follow",
    };
    // setIsRedeem(false)
    // setShowpoints(false)
    fetch(`${baseUrl}/mail/update/redeem`, requestOptions)
      .then(async (response) => {
        const res = await response.text();
        let data = {};
        try {
          data = res ? JSON.parse(res) : {};
        } catch {
          data = {};
        }
        if (!response.ok) {
          return { ...data, _error: true, _status: response.status, _raw: res };
        }
        return data;
      })
      .then((result) => {
        setShowDrawer(true);
        if (result?._error) {
          const msg = `${result?.message || ""}`.toLowerCase();
          const alreadyRedeemed =
            result?.seen === true || msg.includes("already");
          if (!alreadyRedeemed) {
            setRedeemError(true);
            setIsRedeem(true);
            setShowpoints(true);
            toast.error("Redeem Unsuccessful!");
          } else if (typeof opts.onSuccess === "function") {
            opts.onSuccess(result);
          }
          return;
        }
        if (typeof opts.onSuccess === "function") {
          opts.onSuccess(result);
        }
        if (result?.seen === false) {
          setTimeout(() => {
            toast.success(result?.message || "Redeem successful!");
          }, 15000);
        }
      })
      .catch(() => {
        setRedeemError(true);
        setIsRedeem(true);
        setShowpoints(true);
        toast.error("Redeem Unsuccessful!");
      });
  };

  const BackMailLoad = () => {
    setReccurLoad(true);
    setCatReccurLoad(true);
    setBrandReccurLoad(true);
  };

  return (
    <>
      {modeldata?.data && modeldata.data.length > 0 && (
        <Modal show={show && openShow === 0} style={{ width: "100%" }}>
          {modeldata?.data?.map((item) => {
            return (
              <div key="" style={modalStyles.overlay}>
                <div style={modalStyles.content}>
                  <button
                    style={modalStyles.Closebutton}
                    onClick={() => handleClose(item?.uuid)}
                  >
                    X
                  </button>
                  <div
                    style={modalStyles.body}
                    onClick={() => goToNextAd(item?.uuid)}
                  >
                    <img
                      src={item?.image}
                      alt="MealBox Offer"
                      style={modalStyles.image}
                    />
                  </div>
                </div>
              </div>
            );
          })}
        </Modal>
      )}

      <Modal
        show={open1}
        onHide={() => setOpen1(false)}
        dialogClassName="custom-modal"
        centered
      >
        <div>
          {Popupaddsdata1?.length > 0 ? (
            <div className="stories-container">
              <Stories
                loop
                keyboardNavigation
                defaultInterval={10000}
                stories={stories2}
                height={300}
                width={280}
                onStoryEnd={(s, st) => handleClick1(s)}
                onStoryStart={(s, st) =>
                  handleStoryStart(Popupaddsdata1[s].uuid, s)
                }
                onAllStoriesEnd={(s) => handleClick1(s)}
              />
            </div>
          ) : (
            <div style={{ textAlign: "center" }}>No Popup Adds</div>
          )}
        </div>
      </Modal>

      <div css={classes.pageContainer}>
        <AppBar
          variant="home"
          {...useGetNavItems({
            handleNavLinksClick,
            selCountry,
            selState,
            selCity,
            setSelCity,
            setSelCountry,
            setSelState,
            setSelCounty,
            setcityactive,
            selCounty,
            selCategory,
            cityData,
            selBrand,
            setSelBrand,
            subCatActive,
            onDrawerNotification,
            handleClickOpen1,
            Popupaddsdata,
          })}
          onDrawerHandler={onDrawerHandler}
          drawerWidth={drawerWidth}
        />

        {/* <Box css={classes.flex}> */}
        {/* {categoryList?.length > 0 && <Drawer
          anchor={'left'}
          variant="persistent"
          open={showLeftDrawer}
          css={[classes.sideDrawer, {
            width: drawerWidth,
            [`& .MuiDrawer-paper`]: { width: drawerWidth, boxSizing: 'border-box', marginTop: 80 },
          }]}
          onClose={(e) => setShowLeftDrawer(!showLeftDrawer)}
        >
          {categoryList.map((list, i) => {
            return (<ListItem key={i} component="div" disablePadding>
              <ListItemButton selected={selCategory === list.uuid ? true : false} key={i} onClick={(e) => { onChangeCategoryHandler(list.uuid); }} sx={{ '.Mui-selected': { background: '#efefef' } }}>
                <ListItemText primary={`${list.name}`} /><span >{`${list.mails_count === 0 ? "" : list.mails_count}`}</span>
              </ListItemButton>
            </ListItem>)
          })}
        </Drawer>} */}

        <Box
          component="main"
          sx={{
            flexGrow: 1,
            marginLeft: showLeftDrawer ? 0 : `-${drawerWidth}px`,
          }}
        >
          <CampaignsPanel
            campaigns={activeCampaigns}
            count={activeCampaignCount}
            isLoading={isActiveCampaignsLoading}
            isError={isActiveCampaignsError}
            onOpenCampaign={(uuid) =>
              navigate(`/campaigns/${uuid}`, { state: { selCity } })
            }
            onViewAll={() => navigate("/campaigns", { state: { selCity } })}
            onViewBookings={() => navigate("/my-bookings")}
            compact
          />
          {categoryList?.length > 0 && (
            <div
              css={{
                display: "flex",
                overflowX: "auto",
                // "safe center" centers the row when every chip fits, but
                // falls back to start-aligned the moment it overflows.
                // Plain "center" on an overflowing flex row makes the
                // leading items unreachable by scroll in most browsers —
                // the row appears "not centered" with few items and loses
                // content with many, which is the actual root cause here.
                justifyContent: "safe center",
                gap: 8,
                padding: "4px 16px 6px",
                WebkitOverflowScrolling: "touch",
                // The global hover-reveal policy (App.css) depends on a
                // real `:hover` state, which touch/mobile browsers never
                // give a narrow row like this one — so instead of showing
                // briefly on hover, it rendered as a permanently-visible,
                // space-reserving bar (adding ::-webkit-scrollbar CSS
                // anywhere switches Chrome off its space-free overlay
                // rendering). The ">" arrow button already signals there's
                // more to scroll to, so the scrollbar itself is hidden
                // outright here rather than relying on hover.
                "&::-webkit-scrollbar": { display: "none" },
                scrollbarWidth: "none",
                msOverflowStyle: "none",
              }}
            >
              {categoryList.map((item) => {
                const isSelected = selCategory === item?.uuid;
                const Icon = getCategoryIcon(item?.name);
                return (
                  <div
                    key={item?.uuid}
                    role="button"
                    tabIndex={0}
                    onClick={() => onChangeCategoryHandler("", item?.uuid)}
                    onKeyDown={(e) => {
                      if (e.key === "Enter" || e.key === " ") {
                        e.preventDefault();
                        onChangeCategoryHandler("", item?.uuid);
                      }
                    }}
                    style={{
                      width: 76,
                      flexShrink: 0,
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      cursor: "pointer",
                    }}
                  >
                    <div
                      style={{
                        width: 64,
                        height: 64,
                        borderRadius: "50%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        overflow: "hidden",
                        background: isSelected ? CATEGORY_HIGHLIGHT : "#fff",
                        boxShadow: isSelected
                          ? "0 3px 6px rgba(17,24,39,0.14)"
                          : "0 3px 6px rgba(17,24,39,0.1)",
                      }}
                    >
                      {item?.image ? (
                        <img
                          src={item.image}
                          alt=""
                          style={{
                            width: 44,
                            height: 44,
                            objectFit: "contain",
                          }}
                        />
                      ) : (
                        <Icon
                          sx={{
                            fontSize: 32,
                            color: isSelected ? "#fff" : "#111827",
                          }}
                        />
                      )}
                    </div>
                    <span
                      style={
                        isSelected
                          ? {
                              marginTop: 6,
                              maxWidth: "100%",
                              padding: "4px 12px",
                              borderRadius: 999,
                              background: "rgba(255, 255, 255, 0.92)",
                              backdropFilter: "blur(6px)",
                              WebkitBackdropFilter: "blur(6px)",
                              boxShadow: "0 2px 6px rgba(17,24,39,0.1)",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              fontSize: 11,
                              lineHeight: "14px",
                              fontWeight: 700,
                              color: CATEGORY_HIGHLIGHT,
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                            }
                          : {
                              width: "auto",
                              maxWidth: "100%",
                              marginTop: 6,
                              padding: "3px 10px",
                              borderRadius: 999,
                              background: "rgba(255, 255, 255, 0.55)",
                              backdropFilter: "blur(6px)",
                              WebkitBackdropFilter: "blur(6px)",
                              fontSize: 11,
                              lineHeight: "14px",
                              fontWeight: 600,
                              color: "#111827",
                              textAlign: "center",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              display: "-webkit-box",
                              WebkitLineClamp: 2,
                              WebkitBoxOrient: "vertical",
                            }
                      }
                    >
                      <span
                        style={
                          isSelected
                            ? { overflow: "hidden", textOverflow: "ellipsis" }
                            : undefined
                        }
                      >
                        {item?.name || "Category"}
                      </span>
                    </span>
                  </div>
                );
              })}
            </div>
          )}
          {data.length > 0 && (
            <ScrollingCarousel className="scrollingCarousal">
              {data.map((item) => (
                <img
                  key={uuid()}
                  src={`${item?.image}`}
                  css={classes.offerImg}
                  alt="scrollimage"
                />
              ))}
            </ScrollingCarousel>
          )}
          <div css={classes.brandCardsWrapper}>
            {isBrandLoading === true && (
              <Box
                sx={{
                  display: "flex",
                  gap: "8px",
                  px: 1,
                  py: 1,
                  overflow: "hidden",
                  width: "100%",
                }}
              >
                {Array.from({ length: 5 }).map((_, i) => (
                  <Box
                    key={i}
                    sx={{
                      flexShrink: 0,
                      width: 104,
                      borderRadius: "14px",
                      overflow: "hidden",
                      background: "#fff",
                      border: "1px solid rgba(0,0,0,0.09)",
                      boxShadow: "0 3px 14px rgba(0,0,0,0.1)",
                      position: "relative",
                    }}
                  >
                    {/* Store header skeleton — matches compact storeHeader padding: 10px 8px 32px */}
                    <Skeleton
                      variant="rectangular"
                      width={104}
                      height={54}
                      sx={{ bgcolor: "rgba(46,125,50,0.18)", display: "block" }}
                    />
                    <Box sx={{ position: "absolute", top: 6, left: 6 }}>
                      <Skeleton
                        variant="circular"
                        width={18}
                        height={18}
                        sx={{ bgcolor: "rgba(255,255,255,0.4)" }}
                      />
                    </Box>
                    {/* Circular logo skeleton — marginTop: -36px overlapping header */}
                    <Box
                      sx={{
                        position: "absolute",
                        left: "50%",
                        transform: "translateX(-50%)",
                        top: 18,
                        width: 72,
                        height: 72,
                        borderRadius: "50%",
                        border: "2px solid #fff",
                        boxShadow: "0 2px 10px rgba(0,0,0,0.15)",
                        background: "#f1f8f0",
                        zIndex: 2,
                        overflow: "hidden",
                      }}
                    >
                      <Skeleton
                        variant="circular"
                        width={72}
                        height={72}
                        sx={{ bgcolor: "rgba(0,0,0,0.07)" }}
                      />
                    </Box>
                    <Box
                      sx={{
                        paddingTop: "42px",
                        padding: "42px 6px 10px",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        gap: "4px",
                        background: "#fafafa",
                      }}
                    >
                      <Skeleton
                        variant="rounded"
                        width="70%"
                        height={10}
                        sx={{ bgcolor: "rgba(0,0,0,0.08)" }}
                      />
                      <Box
                        sx={{
                          display: "flex",
                          gap: "4px",
                          justifyContent: "center",
                          mt: 0.5,
                        }}
                      >
                        <Skeleton
                          variant="circular"
                          width={22}
                          height={22}
                          sx={{ bgcolor: "rgba(84,172,52,0.12)" }}
                        />
                        <Skeleton
                          variant="circular"
                          width={22}
                          height={22}
                          sx={{ bgcolor: "rgba(84,172,52,0.12)" }}
                        />
                      </Box>
                    </Box>
                  </Box>
                ))}
              </Box>
            )}
            <div
              css={{
                // Single scrollable line, same pattern as the category
                // chips row above it — a wrapping grid wasn't practical once
                // a category had more than a couple of stores.
                width: "100%",
                display: "flex",
                flexWrap: "nowrap",
                overflowX: "auto",
                // Setting overflow-x alone makes the browser compute
                // overflow-y as "auto" too (a UA can't leave one axis
                // `visible` while the other isn't), turning this row into a
                // vertical clip box as well — cutting off the mail-count
                // badge's `top: -8px` offset on each StoreCard. This padding
                // just gives that offset (plus the card's own margin) room
                // to sit inside the row's box instead of poking past it.
                paddingTop: 10,
                // See the category row above for why this is "safe center"
                // and not plain "center" — same overflow-clips-content issue
                // applies here once a category has enough stores to scroll.
                justifyContent: "safe center",
                WebkitOverflowScrolling: "touch",
                // See the category row above — hover-reveal never engages
                // on touch, so this hides the scrollbar outright instead.
                "&::-webkit-scrollbar": { display: "none" },
                scrollbarWidth: "none",
                msOverflowStyle: "none",
              }}
            >
              {isBrandLoading === false &&
                barndList?.length > 0 &&
                barndList?.map((item) => {
                  if (!item?.is_active) return null;

                  return (
                    <StoreCard
                      key={item?.uuid}
                      item={item}
                      selBrand={selBrand}
                      classes={classes}
                      compact
                      onFavouriteToggle={onFavouriteToggle}
                      // Selecting a store only changes which card is
                      // highlighted and which brand's mails/offers load
                      // (both already handled by onBrandSelect itself) — the
                      // store/sub-category/category lists were being
                      // refetched from scratch on every click even though
                      // none of their filters (category/country/state/city/
                      // county) actually changed, which is what caused the
                      // whole store row to flash a loading spinner on each
                      // selection.
                      onBrandSelect={onBrandSelect}
                    />
                  );
                })}
            </div>

            {brandCount === 0 && isBrandLoading === false && (
              <div css={[classes.noResult]}>
                <p>{COMING_SOON}</p>
              </div>
            )}
          </div>
          <MailGrid
            classes={classes}
            tabs={homeTabs}
            subCategoryList={subCategoryList}
            isSubCatLoading={isSubCatLoading}
            isBrandLoading={isBrandLoading}
            mailList={mailList}
            mailCount={mailCount}
            isMailLoading={isMailLoading}
            subCatActive={subCatActive}
            tabIndexs={tabIndexs}
            setTabindexs={setTabindexs}
            checkseen={checkseen}
            onActivefunct={activefunct}
            totalRedeemedPoints={totalRedeemedPoints}
            totalMailCount={totalMailCount}
            unreadMailCount={unreadMailCount}
            subscribeshow={subscribeshow}
            setSubscribeShow={setSubscribeShow}
            selBrand={selBrand}
            selCategory={selCategory}
            selCountry={selCountry}
            selState={selState}
            selCity={selCity}
            selCounty={selCounty}
            userDetails={userDetails}
            onTabChange={onTabChane}
            onFavouriteMailToggle={onFavouriteMailToggle}
            onUnsubscribeMail={unSubscribeMail}
            onOfferCardClick={(_item, idx) => {
              setCurrentIndex(idx);
              setShowVideo(true);
              setSelectedOfferIndex(idx);
              handleNavLinksClick("offerCard", _item);
            }}
            onMoreMailsClick={() =>
              navigate(
                `/moreMails?country_uuid=${selCountry}&state_uuid=${selState}&city_uuid=${selCity}&sub_category_uuid=${subCatActive ?? ""}&user_uuid=${userDetails?.uuid}&county_uuid=${selCounty}&selCategory=${selCategory ?? ""}&brand_uuid=${selBrand}&type=filter`,
                {
                  state: {
                    selCountry,
                    selState,
                    selCity,
                    selCounty,
                    selCategory,
                    selBrand,
                  },
                },
              )
            }
            doYouKnowTabUuid={DO_YOU_KNOW_TAB_UUID}
            isDoYouKnowConfigured={isDoYouKnowConfigured}
            isDoYouKnowLoading={isDoYouKnowLoading}
            doYouKnowError={doYouKnowError}
            hasDoYouKnowData={hasDoYouKnowData}
            doYouKnowData={doYouKnowData}
            quickOffersTabUuid={QUICK_OFFERS_TAB_UUID}
            isQuickOffersLoading={isQuickOffersLoading}
            quickOffersError={quickOffersError}
            quickOffersData={quickOffersData}
            promotionsData={promotionsData}
          />
        </Box>

        {/* </Box> */}
        <div>
          {/* <AppFooter /> */}
          <Footer1 />
        </div>

        <Drawer
          anchor="top"
          open={showDrawer}
          onClose={toggleDrawer}
          PaperProps={{
            sx: classes.drawer,
          }}
          sx={[classes.drawerContainer, { zIndex: 1277 }]}
        >
          {renderDrawerContent()}
        </Drawer>
        {/* {isRedeem && <Snackbar message={redeemMessage} isOpen={isRedeem} severity={redeemError ? 'error' : 'success'} />} */}
        {showpoints && currentCard?.type === "paid" && redeemtoast && (
          <Snackbar
            message={redeemMessage?.message}
            isOpen={showpoints}
            severity={redeemError ? "error" : "success"}
          />
        )}
        {locationCheck && (
          <Snackbar
            message={"Favourite Not Possible"}
            isOpen={locationCheck}
            severity={"error"}
          />
        )}
        {redeemmsgs && currentCard?.type === "paid" && (
          <Snackbar
            message={redeemmsg}
            isOpen={redeemmsgs}
            severity={"success"}
          />
        )}
        {showRightDrawer && (
          <ClickAwayListener onClickAway={handleClickAway}>
            <Drawer
              anchor={"right"}
              variant="persistent"
              open={showRightDrawer}
              // onClose={toggleDrawer(anchor, false)}
              ModalProps={{
                onBackdropClick: (e) => setShowRightDrawer(!showRightDrawer),
              }}
              css={[
                classes.sideDrawer,
                {
                  width: drawerWidth,
                  // style={{ width: "326px", marginTop: "117px" }}
                  [`& .MuiDrawer-paper`]: {
                    width: drawerWidth,
                    boxSizing: "border-box",
                    marginTop: 80,
                    width: 330,
                    marginTop: 117,
                    height: 410,
                    overflowX: "hidden",
                  },
                },
              ]}
              onClose={(e) => setShowRightDrawer(!showRightDrawer)}
            >
              <h4 style={{ marginLeft: "41px", marginTop: "28px" }}>
                Notifications
              </h4>
              {noticationdata?.slice(0, itemsToShow).map((items) => {
                return (
                  <>
                    {/* onClick={(event) => {navigationView(item.link);NotificationUpdateseen(item?.uuid)}} */}
                    {items?.is_seen === true ? (
                      <div
                        className="container"
                        style={{ marginLeft: "11px", cursor: "pointer" }}
                        onClick={(event) => {
                          setShowRightDrawer(false);
                          navigationView(items.link);
                          NotificationUpdateseen(items?.uuid);
                        }}
                      >
                        <h6>
                          <span
                            class="dot"
                            style={{
                              height: "10px",
                              width: "10px",
                              backgroundColor: "green",
                              borderRadius: "50%",
                              display: "inline-block",
                              marginRight: "10px",
                            }}
                          ></span>
                          {items.title}
                        </h6>
                        <p style={{ marginLeft: "20px", width: "200px" }}>
                          {items.message}
                        </p>
                      </div>
                    ) : (
                      <div
                        className="container"
                        style={{ marginLeft: "11px", cursor: "pointer" }}
                        onClick={(event) => {
                          setShowRightDrawer(false);
                          navigationView(items.link);
                          NotificationUpdateseen(items?.uuid);
                        }}
                      >
                        <h6>
                          <span
                            class="dot"
                            style={{
                              height: "10px",
                              width: "10px",
                              backgroundColor: "red",
                              borderRadius: "50%",
                              display: "inline-block",
                              marginRight: "10px",
                            }}
                          ></span>
                          {items.title}
                        </h6>
                        <p style={{ marginLeft: "20px", width: "200px" }}>
                          {items.message}
                        </p>
                      </div>
                    )}
                  </>
                );
              })}
              <NavLink
                to="/Notifications"
                style={{ color: "green", marginLeft: "76px" }}
              >
                <u>View More</u>
              </NavLink>
            </Drawer>
          </ClickAwayListener>
        )}
      </div>
    </>
  );
};

export default memo(MobileHome);
